// English texts of the "history" area (a map's history: interfaces/classic/ui/history.js). Keys start with "history."
export default {
  "history.title": "History of {title}",
  "history.menu": "History",
  "history.section": "History",
  "history.sectionHint": "Earlier versions of this map, who changed what, and how to bring something back.",
  "history.loading": "Loading…",
  "history.timeline": "Timeline",
  "history.groupRecent": "Last 7 days",
  "history.groupOlder": "Earlier",
  "history.today": "Today",
  "history.at": "{day}, {time}",
  "history.between": "{day}, {from}–{to}",
  "history.you": "You",
  "history.someone": "Someone",
  "history.olderApp": "Someone (older app)",
  "history.mismatch": "Someone (records don't match)",
  "history.nobody": "No one",
  "history.changes_one": "{count} change",
  "history.changes_other": "{count} changes",
  "history.oldest": "Oldest version kept",
  "history.empty": "No history yet. It starts with the next changes saved online.",
  "history.emptyDetail": "Choose a moment on the left once the map has some history.",
  "history.notOnline": "History is kept for maps saved online. This map has nothing on the server yet.",
  "history.unavailable": "History unavailable: {error}",
  "history.unreadable": "This version cannot be read with your keys: it is from before you had access to this map, or from before its key changed.",
  "history.since": "History since you joined this map ({date}).",
  "history.tabChanges": "What changed",
  "history.tabMap": "The map then",
  "history.compareWith": "Compare with",
  "history.compareBefore": "just before",
  "history.comparePrevious": "the version before",
  "history.compareNow": "the map now",
  "history.noChange": "No change between these two moments.",
  "history.before": "Before",
  "history.after": "After",
  "history.moved": "Moved among its siblings",
  "history.kind.created": "Added",
  "history.kind.deleted": "Deleted",
  "history.kind.modified": "Changed",
  "history.count.created_one": "{count} added",
  "history.count.created_other": "{count} added",
  "history.count.deleted_one": "{count} deleted",
  "history.count.deleted_other": "{count} deleted",
  "history.count.modified_one": "{count} changed",
  "history.count.modified_other": "{count} changed",
  "history.field.name": "Title",
  "history.field.notes": "Notes",
  "history.field.parent": "Under",
  "history.field.position": "Position",
  "history.field.startDate": "Start",
  "history.field.endDate": "End",
  "history.field.status": "Status",
  "history.field.tags": "Tags",
  "history.field.color": "Color",
  "history.field.effort": "Effort",
  "history.field.effortUnit": "Effort unit",
  "history.field.estimate": "Estimate",
  "history.field.priority": "Priority",
  "history.field.assignee": "Assignee",
  "history.field.link": "Link",
  "history.field.linkedDocId": "Linked map",
  "history.bringBackDeleted": "Bring it back",
  "history.bringBackAsWas": "Bring back as it was",
  "history.broughtBack": "\"{name}\" is back as it was",
  "history.readOnly": "You can only read this map.",
  "history.failed": "That did not work: {error}",
  "history.outlineHint": "The map as it was, read-only. Select text to copy it, or tick items and copy them, then paste them into a map with Ctrl+V.",
  "history.pick": "Pick \"{name}\"",
  "history.copyItems": "Copy the ticked items",
  "history.itemsCopied_one": "{count} item copied: paste it into a map with Ctrl+V",
  "history.itemsCopied_other": "{count} items copied: paste them into a map with Ctrl+V",
  "history.copiedItems": "Copied items",
  "history.noMap": "This version has no readable map.",
  "history.copy": "Copy as a new map",
  "history.copyName": "{title} ({date})",
  "history.revert": "Revert the map to this moment…",
  "history.openToRevert": "Open this map to revert it",
  "history.revertTitle": "Revert the map?",
  "history.revertIntro": "\"{title}\" will be made as it was on {when}:",
  "history.revertBack_one": "{count} item deleted since comes back",
  "history.revertBack_other": "{count} items deleted since come back",
  "history.revertRemoved_one": "{count} item added since is removed",
  "history.revertRemoved_other": "{count} items added since are removed",
  "history.revertChanged_one": "{count} item changed since goes back to how it was",
  "history.revertChanged_other": "{count} items changed since go back to how they were",
  "history.revertSafe": "Nothing is lost: the map as it is now stays in the history, and Ctrl+Z undoes the revert. The journal, routines and Today list are not changed.",
  "history.revertSubmit": "Revert",
  "history.reverted": "The map is back as it was. Ctrl+Z undoes it.",
  "history.alreadyThere": "The map is already as it was then.",
  "history.deleteVersion": "Delete this version",
  "history.deleteVersionConfirm": "Delete the version of {when}? The other versions stay.",
  "history.deleteAll": "Delete the history",
  "history.deleteAllConfirm": "Delete the whole history of \"{title}\"? The map itself stays as it is. This cannot be undone.",
  "history.uses": "History uses {size} (at most {cap})",
  "history.sizeKB": "{size} KB",
  "history.sizeMB": "{size} MB",
  "history.keep": "Keep",
  "history.keepAll": "every version (3 years)",
  "history.keepNone": "no history",
  "history.keepCount": "the last {n} versions",
  "history.keepNoneConfirm": "Keep no history for this map? Its versions are deleted now and no new ones are kept. This cannot be undone.",
  "history.keepFewerConfirm": "Keep only the last {n} versions? Older ones are deleted now. This cannot be undone.",
};
